/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvD8fU6%7Bborder-radius%3Avar(--ds-radius-large%2C8px)%7D%0A._23rrnHDRYy%7Btransition%3Abox-shadow%20.25s%20ease-in-out%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._2V7sgONvrM%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D%0A._3hxITi6wH8%7Bborder-style%3Asolid%7D%0A._3vBAKH9r67%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._0jFU0VN91d%7Bheight%3A100%25%7D%0A._4ouGXIoaux%7Bmin-width%3A10pc%7D%0A._0Of8r28HPE%7Bpadding-top%3Avar(--ds-space-150%2C9pt)%7D%0A._1Znuxb8HPE%7Bpadding-right%3Avar(--ds-space-150%2C9pt)%7D%0A._1wydGW8HPE%7Bpadding-bottom%3Avar(--ds-space-150%2C9pt)%7D%0A._2Zuz6Q8HPE%7Bpadding-left%3Avar(--ds-space-150%2C9pt)%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._0DCa9D98eZ%3Ahover%7Btext-decoration-color%3AcurrentColor%7D%0A._3932vvYbGa%3Ahover%7Btext-decoration-line%3Anone%7D%0A._02cRtH6wH8%3Ahover%7Btext-decoration-style%3Asolid%7D%0A._0ReiIH7zJH%3Ahover%7Bcursor%3Apointer%7D%0A._4ezyzhQiA2%3Ahover%7Btransition-property%3Abackground-color%7D%0A._1pwPA0pFbM%3Ahover%7Btransition-duration%3A.4s%7D%0A._0t5mr7N8t6%3Ahover%7Btransition-timing-function%3Aease-in-out%7D%0A._3s1x1CUaiG%3Ahover%7Btransition-delay%3A0ms%7D");






















import React from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
const wrapperStyles = {
  root: "_0bjKvD8fU6 _23rrnHDRYy _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02N91d _0jFU0VN91d _4ouGXIoaux _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _1mT5xdRAKS _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0ReiIH7zJH _4ezyzhQiA2 _1pwPA0pFbM _0t5mr7N8t6 _3s1x1CUaiG"
};
export const PersonCardWrapper = ({
  id,
  children,
  testId
}: {
  id: string;
  testId?: string;
  children: React.ReactNode;
}): React.JSX.Element => {
  const [isHovered, setIsHovered] = React.useState(false);
  return <Box xcss={cx(wrapperStyles.root)} backgroundColor={isHovered ? 'elevation.surface.hovered' : 'elevation.surface'} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} testId={testId || `person-card-${id}`}>
			{children}
		</Box>;
};